import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '../components/Pagination';
import { useSearchExport } from '../context/SearchExportContext';
import { getSubscribers } from '../redux/subscriberSlice';
import ExportDropdown from '../context/ExportDropdown';
import RecordsLoader from '../components/RecordsLoader';

const SubscribersList = () => {
    const dispatch = useDispatch();
    const { subscribers, status } = useSelector((state) => state.subscribers);
    const { filterData } = useSearchExport();

    const [currentPage, setCurrentPage] = useState(1);
    const subscribersPerPage = 50;

    useEffect(() => {
        dispatch(getSubscribers());  // Fetch all open calls on component load
    }, [dispatch]);

    const currentsubscribers = filterData(subscribers)
        .slice((currentPage - 1) * subscribersPerPage, currentPage * subscribersPerPage);

    return (
        <div className="container mx-auto p-6">

            {/* Render the loader if the status is 'idle' */}
            {status === 'idle' && <RecordsLoader text="Loading Subscribers, please hold on..." />}

            <h1 className="text-2xl text-black font-bold mb-6">Subscribers List</h1>

            {/* Export Buttons */}
            <ExportDropdown data={subscribers} fileName="subscribers" />

            {/* Loading state */}
            {status === 'failed' && <p>Error loading subscribers</p>}

            {/* Open Call List Table */}
            {status === 'succeeded' && (
                <>
                    <table className="min-w-full table-auto bg-white shadow-md rounded-lg">
                        <thead>
                            <tr className="bg-gray-100 text-left">
                                <th className="px-4 py-2">S.No.</th>
                                <th className="px-4 py-2">Subscribers Email</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentsubscribers.length > 0 ? (
                                currentsubscribers.map((subscriber, index) => (
                                    <tr
                                        key={subscriber.id}
                                        className="border-b cursor-pointer hover:bg-gray-100"
                                    >
                                        <td className="px-4 py-2">{index + 1}</td>
                                        <td className="px-4 py-2">{subscriber.email}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="9" className="text-center py-4">No Subscribers Found!</td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    {/* Pagination */}
                    {subscribers.length > subscribersPerPage && (
                        <Pagination
                            usersPerPage={subscribersPerPage}
                            totalUsers={subscribers.length}
                            paginate={setCurrentPage}
                            currentPage={currentPage}
                        />
                    )}
                </>
            )}
        </div>
    );
};

export default SubscribersList;